<template>
    <div class="page_">
         <div class="top_bar_ clearfix_">
            <div class="w1000_">
                <div v-if="!isLogined" class="left_ f_l_">
                    欢迎登录{{storeName}}，请
                    <span class="c11_">
                        <router-link class="c11_" :to="{name: 'login'}">登录</router-link>
                        <router-link class="c11_" :to="{name: 'register'}">/免费注册</router-link>
                    </span>
                </div>
                <div v-else class="left_ f_l_"><span @click="loginOut()" style="cursor:pointer">退出登录</span></div>
                <div class="right_ f_r_">
                    <a class="mrg_r36_"><router-link :to="{name: 'home'}">首页</router-link></a>
                    <a class="mrg_r36_" style=" margin-left:30px;"><router-link :to="{name: 'aboutUs'}">公司介绍</router-link></a>
                    <a class="mrg_r36_" style=" margin-left:30px;"><router-link :to="{name: 'claimsGuide'}">理赔指引</router-link></a>
                    <a class="vline_" style=" margin-left:30px;"> <router-link :to="{name: 'commonQuestion'}">常见问题</router-link></a>
                    <a class="javascript:void(0)"><router-link  :to="{name: 'contactUs'}">联系我们</router-link></a>
                </div>
            </div>
        </div>
        <div class="content_">
          <img :src="now.imgSrc" alt="">
          <p class="result_">{{now.text}}</p>
          <p v-if="now.value==='2' || now.value==='4'">失败原因：{{message}}</p>
          <p v-if="now.value==='1'">请在<router-link :to="{name: 'ordered'}">“服务中心-已出单保单”</router-link>点击”电子保单”可下载最新版保单</p>
          <p><router-link :to="{name: 'home'}">返回首页</router-link></p>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.page_ {
    font-size: 12px;
    height:100vh;
    .con_{
      width:1000px;
      margin:20px auto;
      padding:30px;
      display:flex;
      flex-wrap:wrap;
      border-top:1px solid #f2f2f2;
      border-bottom:1px solid #f2f2f2;
      .content{
        padding: 30px 30px 10px;
        line-height: 25px;
        text-indent: 2em;
        font-size: 16px;
      }
    }
    .breadcrum_ {
        font-size: 12px;
        color: #666666;
        width:1000px;
        margin: 34px auto 24px;
    }
}
 .top_bar_ {
        background: #001D3B;
        color: #fff;
        font-size: 12px;
        line-height: 33px;
        .left_ {
            white-space: nowrap;
        }
        .vline_ {
            &::after {
                display: inline-block;
                vertical-align: middle;
                content: '';
                width: 1px;
                height: 13px;
                background: #fff;
                margin: 0px 18px;
                margin-top: -1px;
            }
        }
        a {
            color: #fff;
        }
    }
    .content_{
      display:flex;
      flex-direction:column;
      justify-content: center;
      height:calc(100vh - 33px);
      img{
        width:220px;
        height:auto;
        margin:0 auto;
      }
      p{
        text-align:center;
        margin:0 auto;
        &:last-child{
          border:1px solid #FF4C1C;
          height:40px;
          line-height:40px;
          text-align:center;
          border-radius:3px;
          width:150px;
          margin-top:23px;
        }
      }
      .result_{
        font-weight:bold;
        color:#FF4C1C;
        font-size:16px;
        margin:18px auto 10px;
      }
    }
</style>
<script>
import Storage from '@/utils/storage'
import { getToken, setToken, setLogined} from '@/utils/authorized'
import api from '@/utils/api'
const KEY = '_history_search_keyword'
export default {
    data () {
        document.title = '服务中心'
        return {
          resultList:[
            {
              value:'1',
              text:'您的批改已成功！',
              imgSrc:require('../../assets/wxmall/pigais.png')
            },
            {
              value:'2',
              text:'您的批改未成功！',
              imgSrc:require('../../assets/wxmall/pigaif.png')
            },
            {
              value:'3',
              text:'退保成功',
              imgSrc:require('../../assets/wxmall/tuibaos.png')
            },
            {
              value:'4',
              text:'退保失败',
              imgSrc:require('../../assets/wxmall/tuibaof.png')
            }
          ],
          type:'',
          now:{},
          isLogined: getToken() ? true : false,
          logoUrl:'',
          servicePhone:'',
          storeName:'',
          introduceUrl:'',
          message:''
        }   
    },
    mounted () {
      this.type=this.$route.query.type
      let resdata=this.$route.query.data
      this.message=this.$route.query.data.data.returnMsg
      console.log(resdata,'resdata')
      if(this.type==='1'){
        if(resdata.data.returnCode==='0000'){
          this.now=this.resultList[2]
        }else{
          this.now=this.resultList[3]
        }
      }else{
        if(resdata.data.returnCode==='0000'){
          this.now=this.resultList[0]
        }else{
          this.now=this.resultList[1]
        }
      }
    },
    methods: {
      fetchData(){
        api.queryStore({
              userId:590584
          }).then(res => res.data).then(data => {
              if(data.returnCode === '00' && data.content!=''){
                  this.logoUrl=data.content.coreStoreDto.logoUrl
                  this.servicePhone=data.content.coreStoreDto.servicePhone
                  this.storeName=data.content.coreStoreDto.storeName
              }
              
        })
        api.getCorePcstore().then(res => res.data).then(data => {
              if(data.returnCode === '0000' && data.data!=''){
                  this.introduceUrl=data.data.companyIntroduceUrl
              }
        })
      },
      godetail(){
          console.log(getToken(),'getToken()')
          if(getToken()){
              let routeUrl = this.$router.resolve({
                    path: "/sd",
                    query: {sign:getToken()}
                });
             window.open(routeUrl.href, '_blank');
          }else{
              var num = Math.ceil(Math.random() * 10);
              window.router.push({ name: "login", params: { num } });
          }
      },
      loginOut(){
          api.logout().then(res => res.data).then(data => {
             setToken('')
             setLogined(0);
            var num = Math.ceil(Math.random() * 10);
            window.router.push({ name: "login", params: { num } });
        })
      },
    }
}
</script>